import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type MessageId = Branded<string, "MessageId">;
const messageIdPrefix = "message__";
const {
    factory: messageIdFactory,
    assert: isMessageId,
    zodSchema: messageIdZodSchema,
} = genericId<MessageId>(messageIdPrefix, {
    regexMatch: /^(message_)\S+$/,
});

export { isMessageId, messageIdFactory, messageIdPrefix, messageIdZodSchema };
export type { MessageId };
